import React, {Fragment} from 'react'
import {PolarAngleAxis, PolarGrid, PolarRadiusAxis, Radar, RadarChart, ResponsiveContainer} from 'recharts'
import {Button, Col, Row} from 'react-bootstrap'
import Message from './Message'
import MainContainer from './MainContainer'
import ResultDescription from './ResultDescription'

import exploraLogoDark from '../assets/images/explora-logos_black.png'

const AnswerResultDetails = ({answer, hidePrintButton}) => {
    if (!answer) {
        return <Message variant="info">Selecione uma resposta para ver os detalhes.</Message>
    }

    const categoryOrder = [
        'Empreendedor',
        'Autônomo',
        'Líder',
        'Colaborador'
    ]

    const graphData = answer.result
                            .map((r) => ({category: r.name, points: r.points || 0}))
                            .sort(
                                (a, b) =>
                                    categoryOrder.indexOf(a.category) -
                                    categoryOrder.indexOf(b.category)
                            )

    const handlePrint = (e) => {
        e.preventDefault()
        window.print()
    }

    const getHeader = () => (
        <>
            {!hidePrintButton &&
                <Row>
                    <Col className="text-right m-0 p-0">
                        <Button
                            type="button"
                            variant="link"
                            onClick={handlePrint}
                            className="d-print-none p-0"
                        >
                            <i className="fas fa-print"></i> Imprimir
                        </Button>
                    </Col>
                </Row>
            }
            <Row className="d-print-none">
                <Col className="text-left p-2" xs={12} md={6}>
                    <strong>Nome:</strong>
                    <br/>
                    {answer?.name}
                </Col>
                <Col className="text-left p-2" xs={12} md={6}>
                    <strong>Email:</strong>
                    <br/>
                    {answer?.email}
                </Col>
            </Row>

            <Row className="d-none d-print-flex">
                <Col className="text-left p-2" xs={4}>
                    <strong>Nome:</strong>
                    <br/>
                    {answer?.name}
                </Col>
                <Col className="text-left p-2" xs={4}>
                    <strong>Email:</strong>
                    <br/>
                    {answer?.email}
                </Col>
            </Row>
        </>
    )

    return (
        <MainContainer header={getHeader()}>
            <Row>
                <Col xs={9}>
                    <h4
                        className="text-secondary"
                        style={{marginBottom: '0', paddingBottom: '0'}}
                    >
                        Gráfico de Análise de perfil
                    </h4>
                    <p className="text-secondary mb-4">
                        A seguir você poderá analisar o resultado de suas respostas.
                    </p>
                </Col>
                <Col xs={3}>
                    <img
                        src={exploraLogoDark}
                        style={{maxWidth: '100px'}}
                        className="float-right d-none d-print-flex"
                        alt="explora logo"
                    />
                </Col>
            </Row>
            <Fragment>
                <Row style={{minHeight: '350px'}} align="center">
                    <Col>
                        <ResponsiveContainer>
                            <RadarChart data={graphData}>
                                <PolarGrid/>
                                <PolarAngleAxis dataKey="category"/>
                                <PolarRadiusAxis/>
                                <Radar
                                    dataKey="points"
                                    stroke="#e95420"
                                    fill="#e95420"
                                    fillOpacity={0.5}
                                />
                            </RadarChart>
                        </ResponsiveContainer>
                    </Col>
                </Row>
                <Row>
                    <Col>{<ResultDescription result={graphData}/>}</Col>
                </Row>
            </Fragment>
        </MainContainer>
    )
}

export default AnswerResultDetails